export const LANDING_PAGE_URL = 'https://vizion.space';

export const ROUTE_MAP = {
  overview: {
    id: 'overview',
    label: 'The Win City Overview',
  },
  'floor-plan': {
    id: 'floor-plans',
    label: 'Floor Plans',
  },
  masterplan: {
    id: 'master-plan',
    label: 'Master Plan',
  },
  interior: {
    id: 'apartments',
    label: 'Apartments',
  },
  neighborhood: {
    id: 'location',
    label: 'Location',
  },
  amenities: {
    id: 'amenities',
    label: 'Amenities',
  },
};

export const SCENE_IDS = {
  main_view: '68e768a4fa4f187e528e21c2',
  studio: '68fafb7ae62230d4b4453d49',
  '1bedroom': '68fadb0abeb5aead0ada1c6b',
  '2pn': '68fafb04e62230d4b4453c85',
  '3pn': '68faffe9e62230d4b44540ff',
};
